// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@keyframes SearchBox-keyframes__fade-in--1Bu13 {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n", "",{"version":3,"sources":["SearchBox.keyframes.css"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","file":"SearchBox.keyframes.css","sourcesContent":["@keyframes fade-in {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n"]}]);
// Exports
exports.locals = {
	"fade-in": "SearchBox-keyframes__fade-in--1Bu13",
	"fadeIn": "SearchBox-keyframes__fade-in--1Bu13"
};
module.exports = exports;
